import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Button } from '@rideiq/shared/components';

type AddContactButtonProps = {
  onClick: () => void;
};

export const AddContactButton = ({ onClick }: AddContactButtonProps) => (
  <Button
    color="tertiary"
    size="medium"
    onClick={onClick}
    data-testid="add-contact"
    aria-label="Add contact"
    style={{
      fontWeight: '400',
    }}
  >
    <AddRoundedIcon width="1rem" height="1rem" sx={{ marginRight: '8px' }} />
    Add contact
  </Button>
);
